import React from 'react'
import {
  Chip,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import Pagination from '../../../components/hooks/BasePagination'
import colors from '../../../assets/colors'

import ActionsMenu from './ActionsMenu'
import { formatDateTime } from './helpers'

const useStyles = makeStyles({
  chip: {
    borderRadius: '8px',
    fontSize: '14px',
    color: '#FFFF',
  },
})

const List = ({ form, setForm }) => {
  const classes = useStyles()
  const history = useHistory()
  const alerts = useSelector(state => state.alerts.items)
  const meta = useSelector(state => state.alerts.meta)

  const handleChangeRowsPerPage = e => {
    setForm({ ...form, rows: e.target.value, page: 1 })
  }

  const handleChangePage = (event, newPage) => {
    setForm({ ...form, page: newPage })
  }

  const renderStatus = alert => {
    if (!alert.dispatched) {
      return (
        <Chip
          size="small"
          label="Não disparado"
          className={classes.chip}
          style={{ backgroundColor: colors.grayMedium }}
        />
      )
    }

    return (
      <Tooltip
        title={`Primeiro disparo em ${formatDateTime(alert.dispatched_at)}`}
      >
        <Chip
          size="small"
          label="Disparado"
          className={classes.chip}
          style={{ backgroundColor: colors.sucess }}
        />
      </Tooltip>
    )
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellHeader align="left">Título</StyledTableCellHeader>
            <StyledTableCellHeader align="center">
              Situação
            </StyledTableCellHeader>
            <StyledTableCellHeader align="center">
              Leituras
            </StyledTableCellHeader>
            <StyledTableCellHeader align="center">
              Criado em
            </StyledTableCellHeader>
            <StyledTableCellHeader align="center">Ações</StyledTableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {alerts?.map(alert => (
            <TableRow key={alert.id} hover>
              <StyledTableCellBody align="left">
                {alert.title}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {renderStatus(alert)}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {alert.dispatched
                  ? `${alert.read_count} / ${alert.recipients_count}`
                  : '-'}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {formatDateTime(alert.created_at)}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                <ActionsMenu
                  alert={alert}
                  onEdit={item => history.push(`/alerts/create-edit/${item.id}`)}
                />
              </StyledTableCellBody>
            </TableRow>
          ))}

          {!alerts?.length && (
            <TableRow>
              <StyledTableCellBody colSpan={5} align="center">
                Nenhum alerta encontrado
              </StyledTableCellBody>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Pagination
        from={meta?.from}
        to={meta?.to}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={form.rows}
        rows={meta?.total}
        page={form.page}
        handleChangePage={handleChangePage}
      />
    </TableContainer>
  )
}

export default List
